import { render, staticRenderFns } from "./map.vue?vue&type=template&id=36f5d769"
import script from "./map.vue?vue&type=script&lang=ts"
export * from "./map.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports